import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import { usePosContext } from "../context/pos-context";

type PaymentMethod = {
  id: string;
  name: string;
  description: string;
};

const PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: "aba-khqr",
    name: "ABA KHQR",
    description: "Scan to pay with any banking app",
  },
  {
    id: "acleda-khqr",
    name: "ACLEDA KHQR",
    description: "Scan to pay with ACLEDA",
  },
];

export function PosPaymentSelection() {
  const { selectedPaymentId, setSelectedPaymentId } = usePosContext();

  return (
    <div className="flex-1 overflow-y-auto p-4">
      <div className="max-w-md mx-auto space-y-4">
        {PAYMENT_METHODS.map((method) => {
          const isSelected = selectedPaymentId === method.id;
          return (
            <button
              key={method.id}
              type="button"
              onClick={() => setSelectedPaymentId(method.id)}
              className={cn(
                "w-full text-left p-5 rounded-2xl border-2 transition-all shadow-sm hover:shadow-md",
                isSelected
                  ? "border-primary bg-primary/5 shadow-md"
                  : "border-gray-200 bg-white hover:border-gray-300"
              )}
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-xl bg-gray-100 flex items-center justify-center text-2xl flex-shrink-0">
                  {method.id === "aba-khqr" ? "🏦" : "🐦"}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-lg">{method.name}</p>
                  <p className="text-sm text-muted-foreground mt-0.5">
                    {method.description}
                  </p>
                </div>
                {isSelected && (
                  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
                    <Check className="h-5 w-5 text-primary-foreground" />
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
